import { Box, Container, Text, VStack } from "@chakra-ui/react";
import { ReactComponent as Logo } from "assets/logos/s-logo.svg";
import useAuth from "hooks/useAuth";
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { fetchUserProfile } from "store/slices/auth.slice";
import EmailVerification from "./EmailVerification";
import PhoneVerification from "./PhoneVerification";

const EmailPasswordVerification = () => {
  const history = useHistory();
  const { logout, profile, token, login } = useAuth();
  const dispatch = useDispatch();

  useMemo(() => {
    dispatch(fetchUserProfile(token));
  }, [dispatch, token]);

  useEffect(() => {
    if (profile.status === "success" && profile.verification.length === 0) {
      history.replace("/dashboard/home");
    }
  }, [history, profile, token]);

  return (
    <VStack py={["10px", "20px"]} minH="100vh" alignItems="center">
      <Container maxW="lg">
        <Box bg="#fcfcfc" p={["10px", "16px", "28px"]}>
          <VStack>
            <Box
              w={["100px", "initial"]}
              as={Logo}
              cursor="pointer"
              onClick={() => {
                logout();
                history.replace("/");
              }}
            />
            <Text
              textAlign="center"
              fontSize={["32px", "3xl"]}
              mt="24px !important">
              Security Verification
            </Text>
            <Text textAlign="center" fontSize={["sm", "md"]} color="#4e4b66">
              To secure your account, please complete the following
              verification.
            </Text>
          </VStack>

          <VStack gridGap="2rem" marginTop={"2rem"}>
            <Text textAlign="center" fontSize={["sm"]} color="#4e4b66">
              Click on the Send Code button to receive an OTP.
            </Text>
          </VStack>
          <VStack gridGap="2rem">
            <PhoneVerification
              verification={profile.verification}
              profile={profile.data}
              token={token}
              login={login}
            />

            <EmailVerification
              verification={profile.verification}
              profile={profile.data}
              token={token}
              login={login}
            />
          </VStack>
          <VStack gridGap="2rem">
            <Box
              w={["100px", "initial"]}
              as={"div"}
              mt="5rem"
              cursor="pointer"
              onClick={() => {
                logout();
                history.replace("/");
              }}>
              <button
                style={{
                  color: "#03A438",
                  cursor: "pointer",
                }}>
                Logout
              </button>
            </Box>
          </VStack>
        </Box>
      </Container>
    </VStack>
  );
};

export default EmailPasswordVerification;
